import PhotoGrid from '@components/photo-grid/photo-grid.component'
import { withTransaction } from '@elastic/apm-rum-react'
import { CommentsInstagram, Input, Media } from '@hub/shared'
import SelectorPhotoComments from '@src/components/selector-photo-comments/selector-photo-comments.component'
import SelectorPhotoLegend from '@src/components/selector-photo-legend/selector-photo-legend.component'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import './communication.page.scoped.scss'

const CommunicationPageComponent = ({ communication, idProfile, onChange, getValidation }: any) => {
  const [t] = useTranslation('communicationPage')
  const [valid, setValid] = useState({
    textPerfect: !!communication?.textPerfect,
    textComments: !!communication?.textPerfect,
    textZeal: !!communication?.textZeal,
    imagesPerfect: !!communication?.imagesPerfect?.length,
    imagesComments: !!communication?.imagesComments?.length,
    imagesZeal: !!communication?.imagesZeal?.length,
  })

  const updatePhotoLegend = (photo: Media) => {
    handleValidation({ imagesZeal: !!photo })
    if (onChange && typeof onChange === 'function') {
      onChange({ ...communication, imagesZeal: [photo] })
    }
  }

  const updatePhotoComments = (photo: Media, comments: Array<CommentsInstagram> = []) => {
    handleValidation({ imagesComments: !!photo && comments?.length === 3 })
    if (onChange && typeof onChange === 'function') {
      onChange({ ...communication, imagesComments: [photo], comments })
    }
  }

  const handleValidation = useCallback(
    (object?: any) => {
      setValid({ ...valid, ...object })
      const fieldsValid = Object.values(valid).every((value) => value === true)
      if (getValidation && typeof getValidation === 'function') {
        getValidation(fieldsValid)
      }
    },
    [getValidation, valid]
  )

  return (
    <div>
      <section className="section-photos-representation mb-5">
        <PhotoGrid
          className="py-2 justify-content-center"
          name="media-kit-communitcaion-perfect-images"
          size={2}
          errorAlign="center"
          photos={communication?.imagesPerfect || []}
          idProfile={idProfile}
          label={
            <span dangerouslySetInnerHTML={{ __html: t('title') }} style={{ fontSize: '1.15rem', color: 'inherit', fontWeight: 900 }} />
          }
          smallCardSize="165px"
          onChange={(newPhotos) => {
            handleValidation({ imagesPerfect: newPhotos?.length === 2 })
            onChange({ ...communication, imagesPerfect: newPhotos })
          }}
        />
      </section>
      <section className="section-comments pb-5">
        <Input
          type="textarea"
          value={communication?.textPerfect}
          label={
            <div>
              <span style={{ fontSize: 'inherit', color: 'inherit' }}>
                <h5 className="m-0" dangerouslySetInnerHTML={{ __html: t('sectionComment') }} />
                {t('sectionCommentText')}
              </span>
            </div>
          }
          name="text-perfect"
          id="text-perfect"
          maxLength={200}
          onChange={(textPerfect: string) => onChange({ ...communication, textPerfect })}
          onValidate={(isValid: boolean) => handleValidation({ textPerfect: isValid })}
          required
        />
      </section>
      <section className="section-photo-legend mb-5">
        <SelectorPhotoLegend
          label={<h5 className="m-0" dangerouslySetInnerHTML={{ __html: t('sectionPhotoLegend') }} />}
          idProfile={idProfile}
          onChange={updatePhotoLegend}
          photo={communication?.imagesZeal?.length ? communication?.imagesZeal[0] : null}
          name={'communication-photo-zeal'}
        />
      </section>
      <section className="section-comment-language mb-5">
        <Input
          type="textarea"
          value={communication?.textZeal}
          name="text-zeal"
          label={
            <div>
              <span style={{ fontSize: 'inherit', color: 'inherit' }}>
                <h5 className="m-0" dangerouslySetInnerHTML={{ __html: t('sectionCommentLanguage') }} />
                {t('sectionCommentLanguageText')}
              </span>
            </div>
          }
          id="text-zeal"
          maxLength={200}
          onChange={(textZeal: string) => onChange({ ...communication, textZeal })}
          onValidate={(isValid: boolean) => handleValidation({ textZeal: isValid })}
          required
        />
      </section>
      <section className="section-photo-comments mb-5">
        <SelectorPhotoComments
          label={<h5 className="m-0" dangerouslySetInnerHTML={{ __html: t('sectionPhotoComments') }} />}
          idProfile={idProfile}
          onChangeSaveComments={updatePhotoComments}
          photo={communication?.imagesComments?.length ? communication?.imagesComments[0] : null}
          name={'communication-photo-zeal'}
          comments={communication?.comments || []}
        />
      </section>
      <section className="section-react-comments">
        <Input
          type="textarea"
          value={communication?.textComments}
          name="text-communication"
          id="text-communication"
          label={
            <div>
              <span style={{ fontSize: 'inherit', color: 'inherit' }}>
                <h5 className="m-0" dangerouslySetInnerHTML={{ __html: t('sectionReactComments') }} />
                {t('sectionReactCommentsText')}
              </span>
            </div>
          }
          maxLength={200}
          onChange={(textComments: string) => onChange({ ...communication, textComments })}
          onValidate={(isValid: boolean) => handleValidation({ textComments: isValid })}
          required
        />
      </section>
    </div>
  )
}

export default withTransaction('CommunicationPageComponent', 'component')(CommunicationPageComponent)
